export default (theme) => ({
  root: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  noPadding: {
    padding: 0,
  },
});
